import React from 'react'
import { ProgressGraphsStyles } from './Style'
import { achievementGraphHooks } from '../AchievementGraph'
import { Img, NoDataDescription, NoDataTitle, PlaceHolderImg } from 'styles/GlobalStyle';
import ProgressGraphsImg from 'assets/ProgressGraphs.png'
import AssessmentFiltersHeader from 'pages/School/Assessments/AssessmentFiltersHeader';

const ProgressGraphs = () => {
    const filterItems = achievementGraphHooks.useFilterItems()

    return (
        <ProgressGraphsStyles>
            <div className='header-filters'>
                <div>{"הצג נתונים לפי חתך של "} </div>
                <AssessmentFiltersHeader
                    keys={['category']}
                    disabledSearch
                    headerItems={filterItems}
                    assessmentFilters={null}
                    setAssessmentFilters={() => { }}
                />
            </div>
            <div className='content'>
                <NoDataTitle>
                    {"כרגע אין נתונים להשוואה. גרפי ההתקדמות יוצגו לאחר ביצוע מבדקים נוספים."}
                </NoDataTitle>
                <NoDataDescription>
                    {"נכון לעכשיו בוצע רק מבדק אחד ולכן אין נתונים להשוואה."}
                </NoDataDescription>
                <PlaceHolderImg>
                    <Img src={ProgressGraphsImg} />
                </PlaceHolderImg>
            </div>
        </ProgressGraphsStyles>
    )
}

export default ProgressGraphs